import { BaseResponseDTO } from "./base.response.dto";

export class ParaderoListItemDTO {
  uuid: string;
  nombre: string;
  visibleId: string;
  descripcion: string;
  zona: string;
  paradero: boolean;
  terminal: boolean;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

export class ParaderoListDTO {
  hasNext: boolean;
  hasPrev: boolean;
  pageIndex: number;
  pageSize: number;
  totalPageCount: number;
  totalRowCount: number;
  list: ParaderoListItemDTO[];

  constructor(obj?: any) {
    Object.assign(this, obj);
    this.list = obj?.list?.map((item: any) => new ParaderoListItemDTO(item)) || [];
  }
}

export class GetListaParaderosResponseDTO extends BaseResponseDTO {
  success: boolean;
  msg: string;
  data: ParaderoListDTO;

  constructor(obj?: any) {
    super(obj);
    this.data = new ParaderoListDTO(obj?.data);
  }
}
